const Created = 1;
const Edited = 2;
const Deleted = 3;
const Restored = 4;
const Draft = 5;
const OnApproval = 6;
const Disapproved = 7;
const Approved = 8;
const AwaitingArts = 9;
const ArtsApproval = 10;
const DisapprovedArts = 11;
const ApprovedArts = 12;
const AwaitingComprovations = 13; //Finalizadas - Status filter
const ComprovationsApproval = 14;
const DisapprovedComprovations = 15;
const ApprovedComprovations = 16;
const AwaitingReceipt = 17;
const Finished = 18; // Concluídas - Status filter
const Cancelled = 19;
const CustomerApproval = 20;
const OnExecution = 21;
const ControllingApproval = 22;
const WaitingCancellationApproval = 25;
const BriefingRefused = 26;
const ApprovedBroadcasting = 27;

export default {
  Created,
  Edited,
  Deleted,
  Restored,
  Draft,
  OnApproval,
  Disapproved,
  Approved,
  AwaitingArts,
  ArtsApproval,
  DisapprovedArts,
  ApprovedArts,
  ComprovationsApproval,
  DisapprovedComprovations,
  ApprovedComprovations,
  AwaitingReceipt,
  Finished,
  Cancelled,
  CustomerApproval,
  OnExecution,
  AwaitingComprovations,
  ControllingApproval,
  WaitingCancellationApproval,
  BriefingRefused,
  ApprovedBroadcasting
};
